import React from 'react';
import { useEffect, useState, useRef } from "react";
import NavButton from '../../homepage/header-banner/TopNavButton';
import ServerPricing from '../../homepage/header-banner/ServerPricing';
import Footer from '../../homepage/footer/Footer'
import Cloudconsult from '../../homepage/consult/cloudconsult';
import Banner from '../../container/Banner/Banner';
import {
    Container, Row, Col
} from 'react-bootstrap';
import Sidebar from '../../container/Sidebar/Sidebar'
// import '../../container/Sidebar/sidebar.css'
import Titlecloudcompute from "../../container/Card/Components/Titlecloudcompute"
import Contentcloudcard from "../../container/Card/Components/Contentcloudcard"
import Imagecloudcompute from "../../container/Card/Components/Imagecloudcompute"
import CardBoxRow from '../../container/Box/Components/CardBox-Row'
// import { MuiGrid } from '@mui/material';
import CommonTable from '../../container/Table/Components/CommonTable';
import CloudConsultCp from '../../homepage/consult/cloudconsult-cp';
import '../../Style/typo.css'
import Cloudconsult2 from '../../homepage/consult/cloudconsult-2';
import BannerPrivateCloud from '../../container/Banner/banner-privateCloud';
import DividerComponent from '../../container/Divider/divider';
import styled from 'styled-components';
import useIsMobile from '../../container/Sidebar/useIsMobile';
import BannerPrivateCloudVN from '../../container/Banner/banner-privateCloud-vn';
import Cloudconsult2VN from '../../homepage/consult/cloudconsult-2-vn';
import SidebarVN from '../../container/Sidebar/Sidebar-vn';
import FooterEn from '../../detailpageVN/Page/component/footeren';
import BannerPrivateCloudENG from '../../container/Banner/banner-privateCloud-en';
import Cloudconsult2ENG from '../../homepage/consult/cloudconsult-2-en';
import SidebarENG from '../../container/Sidebar/Sidebar-en';
import HeaderEn from '../../detailpageVN/Page/component/headeren';

const Sysfont = styled.div`
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen,
    Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
`;



// Titlecloudcompute
function EnterpriseENG() {
    const isMobile = useIsMobile();
    useEffect(() => {
        document.title = 'Enterprise - Private Kubernetes - Private Cloud';
    }, []);
    return (
        <Sysfont className='App'>
            <HeaderEn />
            <BannerPrivateCloudENG />
            <Container className="main-body">
                <Row>
                    <Col md={12} lg={3}>
                        {!isMobile && <SidebarENG />}
                    </Col>
                    <Col md={12} lg={9} className="right-content">
                        {/* {Titlecloudcompute("엔터프라이즈형")} */}
                        {/* {Contentcloudcard("고성능 Local SSD replication Volume 적용 안정적인 서비스운영","모든 인스턴스에 물리적인 rCPU (1배수) 적용, 고용량의 메모리제공")} */}
                        <MuiGrid container spacing={3}>
                            <MuiGrid item xs={12} sm={12} className='MuiGrid-card'>{CardBoxRow(
                                "<p class='typo-21-sm typo-medium typo-black'>Enterprise Private Kubernetes Cluster</p>",

                                `
                                <p class='typo-14'>The enterprise Private Kubernetes cluster utilizes BareMetal to operate not only Master/Worker nodes but also Block Storage and Object Storage.</p>
                                <p class='typo-14'>The cluster can be configured with a minimum of 5 nodes, with at least 5 for Block Storage and 4 for Object Storage (S3) (Total 13 BareMetal servers needed).</p>
                                
                                <p class='typo-14'>&nbsp;</p>
                                <ul>
                                    <li><p class="typo-14">Large-scale cluster utilizing 13 BareMetal servers.</p></li>
                                    <li><p class="typo-14">A large environment built with BareMetal servers, Ceph block storage, and MinIO object storage, offering high availability and a resilient distributed storage architecture suitable for enterprise applications and data-centric services.\</p></li>
                                    <li><p class="typo-14">Ideal for enterprise applications and data-focused services.</p></li>
                                    <li><p class="typo-14">Infrastructure based on high-performance distributed storage.</p></li>
                                    <li><p class="typo-14">Enables companies operating large-scale database applications, big data processing, and machine learning workloads, supporting extensive microservices-based services.</p></li>
                                </ul>
                                `)}
                            </MuiGrid>
                            <DividerComponent />
                            <MuiGrid item xs={12} className='MuiGrid-card'>{Imagecloudcompute("https://hanbiro.com/assets/images/cloud/en/enterprise-structure.png")}</MuiGrid>
                            <DividerComponent />
                        </MuiGrid>
                        <Cloudconsult2ENG />
                    </Col>
                </Row>
            </Container>

            <FooterEn />
        </Sysfont>
    );
};

const MuiGrid = styled.div`
    padding: 0px,
`

export default EnterpriseENG;